export const VALIDATION_REGEXP = {
  phone: /\+\d\s\([\d]{3}\)\s[\d]{3}\s[\d]{2}\s[\d]{2}/,
};
